export enum Constants {
    MAILBOX_SELECT = 'MAILBOX_SELECT',
    MAILBOX_FOLDER_SELECT = 'MAILBOX_FOLDER_SELECT',
    MAILBOX_FOLDER_LIST_SET = 'MAILBOX_FOLDER_LIST_SET',
    MAILBOX_DOCUMENTS_SET = 'MAILBOX_DOCUMENTS_SET',
    MAILBOX_DOCUMENT_REPLACE = 'MAILBOX_DOCUMENT_REPLACE',
    MAILBOX_DOCUMENTS_CLEAN = 'MAILBOX_DOCUMENTS_CLEAN',
    MAILBOX_DOCUMENTS_SELECT = 'MAILBOX_DOCUMENTS_SELECT',
    MAILBOX_FOLDER_UPDATE_ACTION = 'MAILBOX_FOLDER_UPDATE_ACTION',
    MAILBOX_DOCUMENT_UPDATE = 'MAILBOX_DOCUMENT_UPDATE',
    MAILBOX_UNREAD_COUNT_SET = 'MAILBOX_UNREAD_COUNT_SET',
    MAILBOX_DOCUMENT_REMOVE = 'MAILBOX_DOCUMENT_REMOVE',
    MAILBOX_FOLDER_UPDATE_NAME = 'MAILBOX_FOLDER_UPDATE_NAME',
    MAILBOX_DOCUMENT_REMOVE_BY_ID = 'MAILBOX_DOCUMENT_REMOVE_BY_ID',
    MAILBOX_SET_SEARCH_VALUE = 'MAILBOX_SET_SEARCH_VALUE',
    MAILBOX_LIST_SORTORDER_ACTION = 'MAILBOX_LIST_SORTORDER_ACTION',
    MAILBOX_LIST_FILTERBY_ACTION = 'MAILBOX_LIST_FILTERBY_ACTION',
    MAILBOX_SET_SEARCH_INPUT_TEXT = 'MAILBOX_SET_SEARCH_INPUT_TEXT',
    MAILBOX_SET_SEARCH_OUTSIDE_MAILBOX = 'MAILBOX_SET_SEARCH_OUTSIDE_MAILBOX',
    MAILBOX_DOCUMENT_UNSELECT_BY_ID = 'MAILBOX_DOCUMENT_UNSELECT_BY_ID',
    MAILBOX_DOCUMENT_UNSELECT_BY_IDS = 'MAILBOX_DOCUMENT_UNSELECT_BY_IDS',
    MAILBOX_DOCUMENT_SELECT_BY_ID = 'MAILBOX_DOCUMENT_SELECT_BY_ID',
    MAILBOX_DOCUMENTS_CURRENT_SHOWN_COUNT_SET = 'MAILBOX_DOCUMENTS_CURRENT_SHOWN_COUNT_SET',
    MAILBOX_SET_EDIT_NOTE_DOCUMENT = 'MAILBOX_SET_EDIT_NOTE_DOCUMENT',
    MAILBOX_SET_IS_MAILBOX_MOUNTED = 'MAILBOX_SET_IS_MAILBOX_MOUNTED',
    MAILBOX_SET_SELECTED_FOLDER_ACTION = 'MAILBOX_SET_SELECTED_FOLDER_ACTION',
    MAILBOX_DOCUMENTS_REPLACE = 'MAILBOX_DOCUMENTS_REPLACE',
    MAILBOX_SHOW_BATCH_ERROR = 'MAILBOX_SHOW_BATCH_ERROR',
    MAILBOX_DOCUMENTS_DELETE_FROM_LIST = 'MAILBOX_DOCUMENTS_DELETE_FROM_LIST',
    MAILBOX_DOCUMENTS_WAIT_FOR_UPDATE = 'MAILBOX_DOCUMENTS_WAIT_FOR_UPDATE',
    MAILBOX_DOCUMENTS_MOVE_FOR_UPDATE = 'MAILBOX_DOCUMENTS_MOVE_FOR_UPDATE',
    MAILBOX_DOCUMENT_ADD = 'MAILBOX_DOCUMENT_ADD',
    MAILBOX_ACCESS_UPDATE = 'MAILBOX_ACCESS_UPDATE',
    MAILBOX_USER_ROLES = 'MAILBOX_USER_ROLES',
    MAILBOX_SENDER_SELECT = 'MAILBOX_SENDER_SELECT',
    ADD_SELECTED_SENDER = 'ADD_SELECTED_SENDER',
    MAILBOX_DOCUMENT_SELECT_SINGLEMESSAGE = 'MAILBOX_DOCUMENT_SELECT_SINGLEMESSAGE',
    MAILBOX_IS_GREENLANDIC_SUBSCRIPTION = 'MAILBOX_IS_GREENLANDIC_SUBSCRIPTION',
    MAILBOX_IS_READ_UNREAD_ACTION = 'MAILBOX_IS_READ_UNREAD_ACTION',
}
